import { render, staticRenderFns } from "./DosMediaU1.vue?vue&type=template&id=0c0ed136&scoped=true&"
import script from "./DosMediaU1.vue?vue&type=script&lang=js&"
export * from "./DosMediaU1.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU1.vue?vue&type=style&index=0&id=0c0ed136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ed136",
  null
  
)

export default component.exports